/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
 */
import config from '@/config';
import { FEATURE_GRADING_PROJECTS } from '@/constants/features.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

const RESOURCE = 'portal.grading-project';

function createRouteConfig(path, controller, scopes) {
    return {
        path: [path],
        controller,
        guard: multiGuard([
            getFeaturesGuard(FEATURE_GRADING_PROJECTS),
            getPermissionsGuard([{ resource: RESOURCE, scopes }])
        ])
    };
}

export const routing = [
    createRouteConfig(config.routes.gradingProjects.edit, () => import('./controllers/gradingProject.controller.js'), [
        'edit'
    ]),
    createRouteConfig(
        config.routes.gradingProjects.create,
        () => import('./controllers/gradingProject.controller.js'),
        ['create']
    ),
    createRouteConfig(
        config.routes.gradingProjects.answers,
        () => import('./controllers/gradingProjectAnswers.controller.js'),
        ['view']
    ),
    createRouteConfig(
        config.routes.gradingProjects.umfiAnswers,
        () => import('./controllers/gradingProjectUmfiAnswers.controller.js'),
        ['view']
    ),
    createRouteConfig(
        config.routes.gradingProjects.items,
        () => import('./controllers/gradingProjectItems.controller.js'),
        ['view']
    ),
    createRouteConfig(
        config.routes.gradingProjects.list,
        () => import('./controllers/gradingProjectsList.controller.js'),
        ['view']
    )
];
